"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ReactImageMagnify_1 = require("./src/ReactImageMagnify");
// eslint-disable-next-line import/no-default-export
exports.default = ReactImageMagnify_1.ReactImageMagnify;